import axios from 'axios';
import { msalInstance, loginRequest } from '../config/msalConfig';
import { env } from '../config/env';

export const apiClient = axios.create({
  baseURL: env.API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  async (config) => {
    try {
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        const account = accounts[0];
        const tokenResponse = await msalInstance.acquireTokenSilent({
          ...loginRequest,
          account,
        });

        if (tokenResponse?.accessToken) {
          config.headers.Authorization = `Bearer ${tokenResponse.accessToken}`;
        }
      }
    } catch (error) {
      console.error('Token acquisition failed:', error);
      try {
        await msalInstance.acquireTokenRedirect(loginRequest);
      } catch (redirectError) {
        console.error('Token acquisition redirect failed:', redirectError);
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      console.error('API returned 401. Token might be invalid or backend is not configured correctly.');
    }

    const GENERIC_FALLBACK = 'Something went wrong. Please try again later.';

    if (error.response?.data) {
      const contentType = error.response.headers?.['content-type'] || '';
      if (contentType.includes('application/problem+json') && error.response.data.detail) {
        error.message = error.response.data.detail;
      } else if (typeof error.response.data === 'string' && error.response.data.length > 0) {
        error.message = error.response.data;
      } else if (error.response.data.message) {
        error.message = error.response.data.message;
      } else {
        error.message = GENERIC_FALLBACK;
      }
    } else {
      error.message = GENERIC_FALLBACK;
    }

    return Promise.reject(error);
  }
);

export default apiClient;
